import { Controller } from "@hotwired/stimulus";

export default class UIToastController extends Controller {
  static targets = ["item"];

  close(event) {
    event.preventDefault();

    if (this.hasItemTarget) {
      this.itemTarget.classList.add("hidden");
    }

    this.element.classList.add("hidden");
  }
}
